import { VehiclePartCan } from './vehicle-part-can';
import { VehiclePartAnalog } from './vehicle-part-analog';
import { MonitoringStepStatus } from '../constants/monitoring-step-status';
import { JiraIssueInfo } from './jira-issue-info';


export class Monitoring {
  constructor(public id?,
              public approvalJustification?,
              public lastUpdateDate?,
              public creationDate?,
              public performedDiagnosis?: boolean,
              public isEditable?,
              public isVisible?,
              public canView?,
              public canEdit?,
              public editable?,
              public argosUser?,
              public observation?,
              public vehiclePartCAN?: VehiclePartCan,
              public vehiclePartAnalog?: VehiclePartAnalog,
              public attendingResponsibility?: string,
              public preEvaluationStep?: MonitoringStepStatus,
              public validationStep?: MonitoringStepStatus,
              public conclusionStep?: MonitoringStepStatus,
              public jiraIssueInfo?:  JiraIssueInfo) {}
              }



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/monitoring.ts